import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
// import Topbar from './components/Topbar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AdminLogin from './pages/admin/AdminLogin';
import HomePage from './pages/HomePage';
import AboutSection from './pages/AboutSection';
import ExecutiveDeskPage from './pages/ExecutiveDeskPage';
import ProductDetailPage from './pages/ProductDetailPage';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import CaseStudy from './pages/CaseStudy';
import Gallery from './pages/Gallery';
import ContactDetail from './pages/ContactDetail';
import DesignFitOut from './pages/DesignFitOut';
import CaseStudiesDetails from './pages/CaseStudiesDetails';
import DesignIdeas from './pages/DesignIdeas';
import FAQ from './pages/FAQ';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import WhatsAppFloat from './components/WhatsAppFloat';
import ScrollToTop from './components/ScrollToTop';
// import TawkTo from './components/TawkTo';

// Inner component â€“ must be inside <Router> to use useLocation
function AppShell({ isNavFixed }) {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      {!isAdminRoute && <Navbar />}
      {!isAdminRoute && <WhatsAppFloat />}
      <ScrollToTop />
      <Routes>
        {/* Admin Routes â€“ no Navbar/Footer */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Public Routes */}
        <Route path="/" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <HomePage />
            </main>
          </div>
        } />
        
        <Route path="/about" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <AboutSection />
            </main>
          </div>
        } />
        
        {/* Product Category Routes */}
        <Route path="/office-furniture/:subcategory" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <ExecutiveDeskPage category="Office Furniture" />
            </main>
          </div>
        } />
        <Route path="/office-chairs/:subcategory" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <ExecutiveDeskPage category="Office Chairs" />
            </main>
          </div>
        } />
        <Route path="/storage-solutions/:subcategory" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <ExecutiveDeskPage category="Storage Solutions" />
            </main>
          </div>
        } />
        <Route path="/sofa-lounges/:subcategory" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <ExecutiveDeskPage category="Sofa in Lounge" />
            </main>
          </div>
        } />
        <Route path="/acoustic-solutions/:subcategory" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <ExecutiveDeskPage category="Acoustic Solutions" />
            </main>
          </div>
        } />
        <Route path="/wall-cladding/:subcategory" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <ExecutiveDeskPage category="Wall Cladding" />
            </main>
          </div>
        } />
        
        <Route path="/product/:id" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <ProductDetailPage />
            </main>
          </div>
        } />
        <Route path="/blog" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <BlogPage />
            </main>
          </div>
        } />
        <Route path="/blog/:id" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <BlogDetailPage />
            </main>
          </div>
        } />
        <Route path="/gallery" element={<Gallery />} />
        
        <Route path="/contact" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <ContactDetail />
            </main>
          </div>
        } />

        <Route path="/design-fitout" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <DesignFitOut />
            </main>
          </div>
        } />
        
        <Route path="/case-study" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <CaseStudy />
            </main>
          </div>
        } />
        <Route path="/case-study/:id" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <CaseStudiesDetails />
            </main>
          </div>
        } />
        
        <Route path="/design-ideas" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <DesignIdeas />
            </main>
          </div>
        } />
        
        <Route path="/faq" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <FAQ />
            </main>
          </div>
        } />
        
        <Route path="/privacy" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <PrivacyPolicy />
            </main>
          </div>
        } />
        
        <Route path="/terms" element={
          <div className={`app ${isNavFixed ? 'fixed-nav' : ''}`}>
            <main className="main-content">
              <TermsConditions />
            </main>
          </div>
        } />
        
        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      {!isAdminRoute && <Footer />}
    </>
  );
}

function App() {
  const [isNavFixed, setIsNavFixed] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      setIsNavFixed(window.scrollY > 0);
    };
    
    window.addEventListener('scroll', handleScroll);
    
    // Add global error handler to prevent Tawk.to errors from interfering with navigation
    const handleGlobalError = (event) => {
      // Check if the error is related to Tawk.to
      if (event.error && (
        event.error.message?.includes('tawk.to') ||
        event.error.message?.includes('reportIncident') ||
        event.error.message?.includes('twk-chunk')
      )) {
        // Prevent the error from propagating and interfering with navigation
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
      }
    };

    // Add unhandled promise rejection handler for Tawk.to
    const handleUnhandledRejection = (event) => {
      if (event.reason && (
        event.reason.message?.includes('tawk.to') ||
        event.reason.message?.includes('reportIncident') ||
        event.reason.message?.includes('twk-chunk')
      )) {
        // Prevent the rejection from causing issues
        event.preventDefault();
        return false;
      }
    };

    window.addEventListener('error', handleGlobalError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('error', handleGlobalError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);
  
  return (
    <Router>
      <AppShell isNavFixed={isNavFixed} />
    </Router>
  );
}

export default App;
